// Transporter portal menu items exposed as permission modules.
export const TRANSPORTER_MENU_MODULES = [
  { title: 'EIR', module: 'TRANSPORTER EIR', level: 0 },
  { title: 'Invoicing', module: 'TRANSPORTER INVOICING', level: 0 },
];
